import React from 'react'

import { Form, Col } from '_zari/core'

const MontoTotalFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='TOTAL' htmlFor='input-montoTotal' md={4} />
      <Col md={8}>
        <Form.InputText id='input-montoTotal' className='text-right' value={value} disabled />
      </Col>
    </Form.Group>
  )
}

export default MontoTotalFormGroup
